import { render, staticRenderFns } from "./tradeLeadLike.vue?vue&type=template&id=0fc71df6&scoped=true&"
import script from "./tradeLeadLike.vue?vue&type=script&lang=js&"
export * from "./tradeLeadLike.vue?vue&type=script&lang=js&"
import style0 from "./tradeLeadLike.vue?vue&type=style&index=0&id=0fc71df6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc71df6",
  null
  
)

export default component.exports